export default __webpack_public_path__ + "locales/de/CreateEditRoomDialog.json?hash=f67e6ac791a873b936d42acff7dac764";